import Vue from 'vue'
import i18n from '@/i18n'
import moment from 'moment-timezone'

Vue.filter('uppercase', str => str.toUpperCase())
Vue.filter('first4Chars', str => str.substring(0, 4))
Vue.filter('last4Chars', str => str.substring(str.length - 4))
Vue.filter('translate', (object, attribute) => {
  return object[attribute + '_' + i18n.locale.toUpperCase()] || object[attribute + '_' + i18n.fallbackLocale.toUpperCase()]
})
Vue.filter('date', (str, format) => {
  if (str) {
    let formatStr = format ? String(format) : 'DD MMMM YYYY, hh.mm'
    moment.locale(i18n.locale)
    return moment(String(str)).format(formatStr)
  }
})



// WEBPACK FOOTER //
// ./src/filters/index.js